import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { BackupStationSet, Station, StationGroup, StationSet } from '../model/yard-structure.model';

@Injectable({
  providedIn: 'root'
})

export class StationgroupService {
  constructor(private http: HttpService) { }

  getStationGroups(): Observable<StationGroup[]> {
    return this.http.postWithContext<StationGroup[]>(environment.stationGroupEndpoint + '/stationgroups', {});
  }

  getStations(): Observable<Station[]> {
    return this.http.postWithContext<Station[]>(environment.stationGroupEndpoint + '/stations', {});
  }

  getBackupStationSets(): Observable<BackupStationSet[]> {
    return this.http.postWithContext<BackupStationSet[]>(environment.stationGroupEndpoint + '/backup-station-sets', {});
  }

  saveStationGroups(stationGroups: StationGroup[]): Observable<ServiceResponse> {
    return this.http.postWithContext<ServiceResponse>(environment.stationGroupEndpoint + '/save', stationGroups);
  }

  validateStationSetDeletion(stationSet: StationSet): Observable<ServiceResponse> {
    return this.http.postWithContext<ServiceResponse>(environment.stationGroupEndpoint + '/stationsets/validatedelete', stationSet);
  }
}
